/**
 * The internal dependencies.
 */
import results from 'pages/Results.vue';

export default {
	/**
	 * Route name.
	 *
	 * @type {String}
	 */
	name: 'results',

	/**
	 * Route path.
	 *
	 * @type {String}
	 */
	path: '/results',

	/**
	 * Route component.
	 *
	 * @type {Object}
	 */
	component: results,

	/**
	 * Route meta data
	 *
	 * @type {Object}
	 */
	meta: {
		/**
		 * The title that should be set to the document.
		 *
		 * @type {String}
		 */
		title: 'results'
	}
};
